import { useCallback, useEffect } from 'react';

import pubsub, { PUBSUB } from 'src/lib/pubsub';

/**
 * Hook that listens for generation panel menu open events
 * @param menuType The type of menu to listen for
 * @param onClose Callback function to call when menu should close
 */
export const useListenToGenerationPanelMenuOpen = (menuType: string, onClose: () => void): void => {
  const handleGenerationPanelMenuOpen = useCallback(
    (_: unknown, { openedMenuType }: { openedMenuType: string }): void => {
      if (openedMenuType !== menuType) {
        onClose();
      }
    },
    [menuType, onClose]
  );

  useEffect(() => {
    const token = pubsub.subscribe(
      PUBSUB.OPEN_GENERATION_PANEL_MENU,
      handleGenerationPanelMenuOpen
    );

    return (): void => {
      pubsub.unsubscribe(token);
    };
  }, [handleGenerationPanelMenuOpen]);
};
